import {
  startOfMonth,
  eachDayOfInterval,
  toDate,
  startOfWeek,
  eachWeekOfInterval,
  format,
  eachMonthOfInterval,
  differenceInDays,
  addWeeks,
} from 'date-fns'
import {
  compose,
  map,
  is
} from 'ramda';
import {i18n} from '@/plugins/i18n'
import { locale_mapping_date } from '@/helpers/languages'
export function weeklyDateInterval(startDate, endDate) {
  const start = startOfWeek(startDate)
  const end = startOfWeek(endDate)

  const labels = compose(
    map(date => {
      const startOfTheWeek = format(date, "MMM d", {locale: locale_mapping_date[i18n.locale]})
      const endOfTheWeek = format(startOfWeek(addWeeks(date, 1), { weekStartsOn: 6}), "MMM d", {locale: locale_mapping_date[i18n.locale]})
      return `${startOfTheWeek} - ${endOfTheWeek}`
    }),
    eachWeekOfInterval,
  )({ start, end })

  return labels
}

export function monthlyDateInterval(startDate, endDate) {
  const start = startOfMonth(startDate)
  const end = startOfMonth(endDate)
  const labels = compose(
    map(date => format(date, 'MMM', {locale: locale_mapping_date[i18n.locale]})),
    eachMonthOfInterval,
  )({ start, end })

  return labels
}

export function dailyDateInterval(startDate, endDate) {
  const date = new Date();
  const firstDay = startDate || startOfMonth(date);
  const lastDay = endDate || toDate(date);
  const labels =  eachDayOfInterval({
    start: firstDay,
    end: lastDay,
  }).map(date => format(new Date(date), 'dd MMM', {locale: locale_mapping_date[i18n.locale]}))

  return labels;
}


export const extractDate = (date) => format(date, "yyyy-MM-dd", {locale: locale_mapping_date[i18n.locale]})

export const calculatePercentageOfDateInterval = (startDate, endDate, status = null) => {
  if (status === 'draft' || status === 'not_started') { return 0 }
  else if (status === 'finished') { return 100 }
  else if(startDate && endDate) {
    const _startDate = new Date(startDate)
    const _endDate = new Date(endDate)

    const duration = differenceInDays(_endDate, _startDate)
    const daysPassed = differenceInDays(Date.now(), _startDate)
    const ratio = daysPassed/duration

    if(is(Number, ratio) && ratio >= 0) { return ratio * 100 }
  }

  return 75
}
